<!--<div class="row">-->
<!--    <div class="col-md-6">-->
<!--        <h1>Dashboard</h1>-->
<!--    </div>-->
<!--    <div class="col-md-6 ">-->
<!--            &lt;!&ndash; <app-add-users></app-add-users> &ndash;&gt;-->
<!--    </div>-->
<!--</div>-->

<!--app-users-->
<div class="row">
    <!-- <div class="col-md-6">
        <div class="card">
            <div class="card-body">
                <div echarts [options]="chartOption" class="demo-chart"></div>
            </div>
        </div>
    </div> -->
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="contractsByMonth" echarts [options]="barChartOptions" class="demo-chart">
                    <img [src]="dashboardImageUrl" alt="Logo" class="dashboard-image">
                </div>
            </div>
        </div>
    </div>
<!--    <div class="col-md-6">-->
<!--        <div class="card">-->
<!--            <div class="card-body">-->
<!--                <div class="dropdown">-->
<!--                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                      Status-->
<!--                    </button>-->
<!--                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">   -->
<!--                      <a class="dropdown-item" (click)="updatePie('all')" href="javascript:void(0)">Todas</a>        -->
<!--                      <a class="dropdown-item" (click)="updatePie('approved')" href="javascript:void(0)">Aprobadas</a>-->
<!--                      <a class="dropdown-item" (click)="updatePie('cancelled')"  href="javascript:void(0)">Canceladas</a>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div echarts [options]="pieChartOptions" class="pie-chart"></div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</div>